// The protocol screens' colours in one place. Every value here was read off the
// design, so a card's resting border, its selected border and its number are
// three separate entries rather than one colour used three ways.
export const PROTOCOL_PALETTE = {
  // Status cards: border while idle, border once the card filters the list,
  // and the colour of the count itself - countColor, not 'count', which is the
  // number the card shows.
  status: {
    total:    { border: '#C4DAFC', selectedBorder: '#447DFC', countColor: '#121827' },
    approved: { border: '#C6F6D2', selectedBorder: '#3EA44B', countColor: '#3EA44B' },
    pending:  { border: '#FCF194', selectedBorder: '#C68B0B', countColor: '#C68B0B' },
    draft:    { border: '#E6E7EB', selectedBorder: '#4C5564', countColor: '#4C5564' },
    rejected: { border: '#F7CCCB', selectedBorder: '#D42422', countColor: '#D42422' },
  },
  // Header buttons: a pale fill, a stronger border of the same hue, and text
  // dark enough to read on the fill.
  button: {
    newProtocol:      { text: '#FFFFFF', bg: '#2D5CF3', border: '#2D5CF3' },
    manageCategories: { text: '#7710D2', bg: '#F1E8FD', border: '#D4B4FE' },
    archive:          { text: '#AE540D', bg: '#FDF4CB', border: '#F9D455' },
  },
  // Muted text - labels above a count, secondary lines.
  mutedText: '#4C5564',
} as const
